import { OktaAuth } from '@okta/okta-auth-js';
import config from '../config';

const oktaAuth = new OktaAuth(config.OKTA);

export default oktaAuth;
